import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import "./loginregister.css";
import Image1 from "../../assets/images/login_page_img_two.png";
import { toast } from "react-toastify";
import { apiurl } from "../../Constants";

function ForgorPassword() {
  const [inputFields, setInputfields] = useState({ email: "" });

  const [errors, setErrors] = useState({});

  const validaterrors = (inputvalues) => {
    let errors = {};
    if (inputvalues.email == "") {
      errors.email = "Email ID is required";
    }
    return errors;
  };

  const handlechange = (e) => {
    setInputfields({ ...inputFields, [e.target.name]: e.target.value });
  };

  const handleSubmit = (ev) => {
    ev.preventDefault();
    const validationerrors = validaterrors(inputFields);
    setErrors(validationerrors);

    const forgotEmaildata = async () => {
      try {
        const response = await axios.post(apiurl + "sendResetLinkEmail", {
          email: inputFields.email,
        });
        if (response.status === 200) {
          setInputfields({ email: "" });
          toast.success(response.data.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.error);
      }
    };
    forgotEmaildata();
  };

  return (
    <section className="loginregister_section pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="login-page-padding col-lg-6 col-md-6 col-sm-12"></div>
          <div className="col-lg-6 col-md-6 col-sm-12 right_col">
            <div className="form_inner_box">
              <h2 className="text-center">Forgot Password</h2>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label mb-2">
                    Email ID <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="text"
                    name="email"
                    className="form-control"
                    value={inputFields.email}
                    onChange={handlechange}
                    placeholder=" Email ID"
                  />
                  {errors.email ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {errors.email}
                    </p>
                  ) : null}
                </div>
                <div className="mb-3 text-center">
                  <button className="btn_1_1 " type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ForgorPassword;
